export default "__VITE_ASSET__5bdea040__"